import * as React  from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
// import OtherExpertAnswers from './OtherExpertAnswers';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import EditorTabs from './EditorTabs';
// import DeclinedQuestions from './DeclinedQuestions';
// import Search from './Search';
// import TabsSaved from "./TabsSaved";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function NewEditorExtraTabs() {
  const editorState = useSelector(state=>state.editor);
  const [value, setValue] = React.useState(2);
//   const [tab, setTabValue] = useState(1);
//   const [isTabSearch, setIsTabSearch] = useState(false)

//   const handleTabValue = (value) => {
//     setTabValue(value);
//     setIsTabSearch(true)
// };


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const renderLabel = (text) =>{
    return(
      <span>{text}&nbsp;&nbsp;
      {
        !editorState.declineIsLoading &&  <span style={{    "background": "#808080",'color': '#fff','padding': '4px','fontSize': '14px','borderRadius': '3px'}}>
        {editorState.anotherExpertAnswer.answers && editorState.anotherExpertAnswer.answers.length}
        </span>
      }
    
        </span>
    )
  }
  const renderDeclineLabel = (text) =>{
    return(
      <span>{text}&nbsp;&nbsp;
      {     !editorState.declineIsLoading && <span style={{    "background": "#808080",'color': '#fff','padding': '4px','fontSize': '14px','borderRadius': '3px'}}>
        {editorState.declinedData && editorState.declinedData.length}
        </span> }
      </span>
    )
  }
 
  return (
    <Box sx={{ width: '100%', minHeight:'300px' }}>
    
        {/* <TabsSaved onStateChange={handleTabValue} /> */}
        <EditorTabs/>
    </Box>
  );
}
// onStateChange={handleTabValue}